import { apiFetch } from "./api";

export interface FeedbackPayload {
  first_name: string;
  last_name:  string;
  email:      string;
  message:    string;
}

export interface FeedbackItem {
  id:         number;
  first_name: string;
  last_name:  string;
  email:      string;
  message:    string;
  created_at: string;
}

export function submitFeedback(payload: FeedbackPayload): Promise<FeedbackItem> {
  return apiFetch("/feedback", {
    method: "POST",
    body:   JSON.stringify(payload),
  });
}

export function fetchFeedback(params: { limit?: number; offset?: number } = {}): Promise<{ feedback: FeedbackItem[]; total: number }> {
  const q = new URLSearchParams();
  q.set("limit",  String(params.limit  ?? 50));
  q.set("offset", String(params.offset ?? 0));
  return apiFetch(`/feedback?${q}`);
}
